import { combineReducers } from "redux-immutable";

import StudentAssignmentsState from "../../models/StudentAssignmentsState";
import assignmentsReducer from "./assignments";
import studentAssignmentsMetaReducer from "./meta";

export default combineReducers(
  {
    assignments: assignmentsReducer,
    meta: studentAssignmentsMetaReducer
  },
  () => new StudentAssignmentsState() as any
);
